
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--checkbox condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElCheckboxGroup
        ref="checkboxGroupRef"
        v-bind="contentProps"
        v-on="$listeners"
        :disabled="insetDisabled"
        :value="checked"
        class="condition-item__content"
        @input="change"
    >
        <template v-for="item of finalOption">
            <component :is="checkboxType" :key="item[valueKey]" :label="item[valueKey]">
                {{ item[labelKey] }}
            </component>
        </template>
    </ElCheckboxGroup>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else><component :is="getNode(postfix, checked)"></component></template>
    </div>
</ElFormItem>
